module.exports = __webpack_public_path__ + "img/blog-view-deleted-message.74247ab9.webp";